import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function GuideContents() {
  return <section id="kits" className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto bg-deco-bg scroll-mt-10" data-id="element-87">
      <div className="text-center mb-10 sm:mb-14" data-id="element-88">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl text-deco-text mb-4 font-bold leading-tight" data-id="element-89">
          Todo lo que incluye Flores de Chenille Deco
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-90">
        {/* Kit Inicial */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-[2rem] p-8 shadow-sm border border-deco-warm flex flex-col" data-id="element-91">
          <img src="https://cdn.magicpatterns.com/uploads/tK9jqQy9HEDa5xP3ytXyXe/KIT_INICIAL.png" alt="Kit Inicial" className="w-full h-auto rounded-xl mb-6 shadow-sm border border-deco-warm/50" data-id="element-92" />
          <h3 className="text-2xl font-serif font-bold text-deco-text mb-2" data-id="element-93">
            Kit Inicial
          </h3>
          <p className="text-deco-terra font-bold text-xl mb-4" data-id="element-94">$19.990 ARS</p>
          <p className="text-deco-text/80 mb-8 text-sm sm:text-base" data-id="element-95">
            Ideal para empezar desde cero y crear tus primeras flores simples
            con una guía clara y práctica.
          </p>

          <div className="space-y-5 flex-1" data-id="element-96">
            <div className="flex items-start gap-3" data-id="element-97">
              <CheckCircle2 className="text-deco-terra shrink-0 mt-1" size={20} data-id="element-98" />
              <div data-id="element-99">
                <span className="font-bold text-deco-text block mb-1" data-id="element-100">
                  Módulo 1: Guía de introducción + materiales básicos
                </span>
                <span className="text-sm text-deco-text/70 leading-relaxed block" data-id="element-101">
                  Aprendé qué necesitás para comenzar, cómo elegir materiales,
                  cómo organizarte y cómo preparar tus primeras creaciones.
                </span>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-102">
              <CheckCircle2 className="text-deco-terra shrink-0 mt-1" size={20} data-id="element-103" />
              <div data-id="element-104">
                <span className="font-bold text-deco-text block mb-1" data-id="element-105">
                  Módulo 2: Técnica paso a paso con 10 flores simples
                </span>
                <span className="text-sm text-deco-text/70 leading-relaxed block" data-id="element-106">
                  Modelos fáciles para practicar, entender la técnica y ganar
                  confianza desde el inicio.
                </span>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-107">
              <CheckCircle2 className="text-deco-terra shrink-0 mt-1" size={20} data-id="element-108" />
              <div data-id="element-109">
                <span className="font-bold text-deco-text block mb-1" data-id="element-110">
                  Módulo 3: +50 ideas de inspiración
                </span>
                <span className="text-sm text-deco-text/70 leading-relaxed block" data-id="element-111">
                  Ideas para presentar tus flores, combinarlas, regalarlas o
                  comenzar a mostrarlas como productos.
                </span>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-112">
              <CheckCircle2 className="text-deco-terra shrink-0 mt-1" size={20} data-id="element-113" />
              <div data-id="element-114">
                <span className="font-bold text-deco-text block mb-1" data-id="element-115">
                  Videos tutoriales de apoyo incluidos
                </span>
                <span className="text-sm text-deco-text/70 leading-relaxed block" data-id="element-116">
                  Para ver mejor los movimientos, dobleces, uniones y
                  terminaciones.
                </span>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Mega Kit */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="bg-deco-terra text-white rounded-[2rem] p-8 shadow-xl border border-deco-terra relative flex flex-col transform md:-translate-y-4" data-id="element-117">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white text-deco-terra px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider shadow-sm whitespace-nowrap" data-id="element-118">
            Más elegido / Más completo
          </div>
          <img src="https://cdn.magicpatterns.com/uploads/rPCYHX7t9bN2bgro9snhTC/MEGA_KIT.png" alt="Mega Kit" className="w-full h-auto rounded-xl mb-6 shadow-md border border-white/20" data-id="element-119" />
          <h3 className="text-2xl font-serif font-bold mb-2" data-id="element-120">Mega Kit</h3>
          <p className="font-bold text-xl mb-4" data-id="element-121">$29.990 ARS</p>
          <p className="text-white/90 mb-8 text-sm sm:text-base" data-id="element-122">
            La opción más completa para aprender más modelos, armar ramos y
            empezar a vender tus creaciones desde casa.
          </p>

          <div className="space-y-4 flex-1" data-id="element-123">
            <div className="flex items-center gap-3 pb-2 border-b border-white/20" data-id="element-124">
              <CheckCircle2 className="text-white shrink-0" size={20} data-id="element-125" />
              <span className="font-bold text-lg" data-id="element-126">Todo lo del Kit Inicial</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-127">
              <CheckCircle2 className="text-white/80 shrink-0" size={20} data-id="element-128" />
              <span className="font-medium" data-id="element-129">+20 modelos de flores</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-130">
              <CheckCircle2 className="text-white/80 shrink-0" size={20} data-id="element-131" />
              <span className="font-medium" data-id="element-132">Armado de ramos</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-133">
              <CheckCircle2 className="text-white/80 shrink-0" size={20} data-id="element-134" />
              <span className="font-medium" data-id="element-135">
                Ideas para combinar y presentar tus creaciones
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-136">
              <CheckCircle2 className="text-white/80 shrink-0" size={20} data-id="element-137" />
              <span className="font-medium" data-id="element-138">Guía de Emprendimiento</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-139">
              <CheckCircle2 className="text-white/80 shrink-0" size={20} data-id="element-140" />
              <span className="font-medium" data-id="element-141">+100 ideas de inspiración</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-142">
              <CheckCircle2 className="text-white/80 shrink-0" size={20} data-id="element-143" />
              <span className="font-medium" data-id="element-144">
                Videos tutoriales de apoyo incluidos
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}